import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { Role } from '@shared/models';

import { rolesGetSuccess, rolesLoadSuccess } from './roles.actions';
import { createReducer, on } from '@ngrx/store';

export type RolesState = EntityState<Role>;

export const rolesAdapter = createEntityAdapter<Role>();

export const initialState: RolesState = rolesAdapter.getInitialState();

export const rolesReducer = createReducer(
  initialState,
  on(rolesLoadSuccess, (state, { payload }) => rolesAdapter.upsertMany(payload.content, state)),
  on(rolesGetSuccess, (state, { payload }) => rolesAdapter.addOne(payload, state)),
);
